// @ts-nocheck
import { Fragment, useEffect, useRef, useState, useCallback } from "react";
import { useNavigationStore } from "src/store/navigationStore";
import { useExplorationStore } from "@/store/explorationStore";

// import { Canvas, useFrame, RootState } from "@react-three/fiber";
// import { Splat, OrbitControls, Line } from "@react-three/drei";
import { useHexagonSize } from "src/hooks/useHexagonSize";

import { interpolateVector3Array } from "src/utils/navigation";
import {
  Vector3Point,
  Point3D,
  filterStraightLinePoints,
} from "src/utils/three";
// import * as THREE from "three";

// import {
//   getVenueModelConfig,
//   getAltitude,
//   VenueModelConfig,
// } from "@/const/venue_model/venue_model_config";

import {
  getVenueModelConfigByVenueCode,
  getAltitudeByFloorName,
  VenueModelConfig,
  getBaseUrl,
  getVenueIdByVenueCode,
} from "src/utils/map-util";

import * as pc from "playcanvas";
import {
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  interpolateVector3,
} from "src/utils/game";
import { OrbitControls } from "@playcanvas/react/scripts";
import { useMaterial,useAppEvent } from "@playcanvas/react/hooks";
import { Application, Entity } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  Environment,
} from "@playcanvas/react/components";
import { useEnvAtlas } from "@playcanvas/react/hooks";
import { GSplat, Script } from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";
import { useApp, useSplat, useModel } from "@playcanvas/react/hooks";
import { Gltf } from "@playcanvas/react";

export default function ExplorationTopView() {
  const [modelScaleFactorState, setModelScaleFactorState] =
    useState<number>(0.1);
  const [venueModelConfigState, setVenueModelConfigState] =
    useState<VenueModelConfig | null>(null);

  const latestProgressRef = useRef<number>(0);
  const latestCurrentLevelIndexRef = useRef<number>(0);
  const latestCurrentLevelRef = useRef<string>("");
  const targetAltitudeRef = useRef<number>(0);

  const latestNavigationPositionArrayRef = useRef<pc.Vec3[]>([]);

  const latestCameraPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestCameraLookingPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const { HEX_WIDTH_INNER, HEX_HEIGHT_INNER } = useHexagonSize();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 769);
    };

    checkIsMobile(); // Check on initial render
    window.addEventListener("resize", checkIsMobile);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const DataController = () => {
    const cameraPosition = useExplorationStore((state) => state.cameraPosition);
    const cameraLookingPosition = useExplorationStore(
      (state) => state.cameraLookingPosition,
    );

    useEffect(() => {
      latestCameraPositionRef.current = cameraPosition;
      latestCameraLookingPositionRef.current = cameraLookingPosition;
    }, [cameraPosition, cameraLookingPosition]);

    const currentLevelIndex = useExplorationStore(
      (state) => state.currentLevelIndex,
    );
    useEffect(() => {
      latestCurrentLevelIndexRef.current = currentLevelIndex;
    }, [currentLevelIndex]);

    const currentVenue = useExplorationStore((state) => state.currentVenue);
    const currentLevel = useExplorationStore((state) => state.currentLevel);
    useEffect(() => {
      latestCurrentLevelRef.current = currentLevel;
      if (currentVenue != "") {
        const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
        if (venueModelConfig) {
          const altitude = getAltitudeByFloorName(
            venueModelConfig,
            currentLevel,
          );
          targetAltitudeRef.current = altitude / venueModelConfig.scaleFactor;
          setVenueModelConfigState(venueModelConfig);
          setModelScaleFactorState(venueModelConfig.scaleFactor);
        }
      }
    }, [currentVenue, currentLevel]);

    return <></>;
  };

  const VenueSogs = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorSogParentRef = useRef();
    const allFloorSog = venueModelConfigState.floor.map((floor, i) => {
      if (floor.sog) {
        return (
          <Entity key={floor.index}>
            <SogSplat
              url={baseUrl + venueModelConfigState.folderPath + floor.sog}
              floorIndex={floor.index}
            ></SogSplat>
          </Entity>
        );
      } else {
        return <Fragment key={floor.index}></Fragment>;
      }
    });
    return <Entity ref={floorSogParentRef}>{allFloorSog}</Entity>;
  };

  const FloorMeshs = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorMeshParentRef = useRef();
    const allFloorMesh = venueModelConfigState.floor.map((floor, i) => {
      if (floor.mesh) {
        return (
          <Entity key={floor.index}>
            <FloorMeshModel
              meshUrl={
                baseUrl + venueModelConfigState.folderPath + floor.mesh.url
              }
              meshPosition={floor.mesh.position}
              meshRotationAngle={floor.mesh.rotationAngle}
              meshScale={floor.mesh.scale}
              meshColor={floor.mesh.color ?? "#FFFFFF"}
              meshOpacity={floor.mesh.opacity ?? 1}
              floorIndex={floor.index}
            />
          </Entity>
        );
      } else {
        return <></>;
      }
    });
    return <Entity ref={floorMeshParentRef}>{allFloorMesh}</Entity>;
  };

  const FloorMeshModel = ({
    floorIndex,
    meshUrl,
    meshPosition,
    meshRotationAngle,
    meshScale,
    meshColor,
    meshOpacity,
  }: {
    floorIndex: number;
    meshUrl: string;
    meshPosition: number[];
    meshRotationAngle: number[];
    meshScale: number[];
    meshColor: string;
    meshOpacity: number;
  }) => {
    const meshEntityRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    const color = hexToRgbArray(meshColor);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      console.log("change material");
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const currentMaterial = meshInstance.material;
            const material = currentMaterial.clone();
            meshInstance.material = material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(color[0], color[1], color[2]);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(meshEntityRef.current);
        });
      }
    }, [meshAsset]);

    return (
      <Entity
        ref={meshEntityRef}
        position={[
          meshPosition[0] / modelScaleFactorState,
          meshPosition[1] / modelScaleFactorState,
          meshPosition[2] / modelScaleFactorState,
        ]}
        rotation={meshRotationAngle}
        scale={[
          meshScale[0] / modelScaleFactorState,
          meshScale[1] / modelScaleFactorState,
          meshScale[2] / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={meshAsset} />
      </Entity>
    );
  };

  const SogSplat = ({
    url,
    floorIndex,
  }: {
    url: string;
    floorIndex: number;
  }) => {
    const app = useApp();
    const floorRef = useRef();

    let lastUpdate = 0;
    const UPDATE_INTERVAL = 1 / 1;

    const handleUpdate = useCallback((dt: number) => {
      lastUpdate += dt;
      if (lastUpdate >= UPDATE_INTERVAL) {
        updateFrame();
        lastUpdate = 0;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const updateFrame = (dt: number) => {
      if (
        latestCurrentLevelIndexRef.current != null &&
        floorRef.current != null
      ) {
        if (latestCurrentLevelIndexRef.current == floorIndex) {
          floorRef.current.enabled = true;
        } else {
          floorRef.current.enabled = false;
        }
      }
    };

    const { asset } = useSplat(url);
    return (
      <Entity
        enabled={false}
        ref={floorRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <GSplat asset={asset} />
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const mainObjectEntityRef = useRef();
    const cameraScriptRef = useRef();
    const cameraRef = useRef();
    let _localProgress;
    let finalCameraPosition = new pc.Vec3(0, 0, 0);
    let finalCameraLookingPosition = new pc.Vec3(0, 0, 0);

    let _localCameraPosition;

    const handleUpdate = useCallback((dt: number) => {
      if (!cameraScriptRef.current) {
        return;
      }

      let isCameraPositionUpdated =
        _localCameraPosition != latestCameraPositionRef.current;
      _localCameraPosition = latestCameraPositionRef.current;

      finalCameraPosition = new pc.Vec3(
        _localCameraPosition.x,
        _localCameraPosition.y + 50,
        _localCameraPosition.z,
      );

      finalCameraLookingPosition = new pc.Vec3(
        _localCameraPosition.x,
        _localCameraPosition.y,
        _localCameraPosition.z - 0.001,
      );

      cameraScriptRef.current.reset(
        finalCameraLookingPosition,
        finalCameraPosition,
      );
    }, []);
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      const defaultPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState + 50,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      mainObjectEntityRef.current.setPosition(defaultPosition);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity>
          <Camera clearColor="#000000" />
          <Script
            ref={cameraScriptRef}
            script={CameraControls}
            enableFly={false}
          />
        </Entity>
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        <VenueSogs />
        <FloorMeshs />
        <Environment exposure={1.0} luminance={0.4} />
        <MainObject />
      </>
    );
  };

  const TopDownScene = () => {
    return (
      <Application>
        {venueModelConfigState != null && modelScaleFactorState > 0 ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const DirectionLight = () => {
    const cameraAngle = useExplorationStore((state) => state.cameraAngle);
    return (
      <div
        className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
        style={{ transform: `rotate(${cameraAngle + 180}deg)` }}
      >
        {/*<div className="fixed w-[60px] h-[50px] left-1/2 -translate-x-1/2 -translate-y-full bg-gradient-to-t from-[#FFFFFFDD] to-[#FFFFFF00] [clip-path:polygon(0_0,100%_0,60%_100%,40%_100%)]"></div>*/}
        <div className="fixed w-[80px] left-1/2 -translate-x-1/2 -translate-y-full">
          <img
            src="/assets/spotlight.png"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    );
  };

  const LogoDot = () => {
    const cameraAngle = useExplorationStore((state) => state.cameraAngle);
    return (
      <div style={{ transform: `rotate(${cameraAngle + 180}deg)` }}>
        <img
          src="/assets/icon_logo_dot.png"
          className="w-full h-full object-cover"
        />
      </div>
    );
  };

  return (
    <div
      id="navi-top-view-parent"
      className={`relative hex-crop ${isMobile ? "mobile" : "desktop"} pointer-events-none`}
      style={{
        width: `${HEX_WIDTH_INNER}px`,
        height: `${HEX_HEIGHT_INNER}px`,
      }}
    >
      <div
        className={`relative left-0 bottom-0 h-[100%] w-[100%] transform rotate-180 overflow-hidden`}
      >
        <div
          className={`absolute h-[100%] w-[100%] overflow-hidden bg-black`}
        />

        <div
          id="div-above-canvas"
          className="absolute left-0 bottom-0"
          style={{
            width: `${HEX_WIDTH_INNER}px`,
            height: `${HEX_HEIGHT_INNER}px`,
          }}
        >
          <DataController />
          <TopDownScene />
        </div>

        <div className="absolute top-1/2 left-1/2 w-[20px] h-[20px] -translate-x-1/2 -translate-y-1/2">
          <DirectionLight />
          <LogoDot />
        </div>
      </div>
    </div>
  );
}
